import { IntentType } from '../dataType';

export const Intents: IntentType[] = ['work_report', 'sql_query', 'risk'];
